import React, { useEffect, useState } from 'react'
import WaterfallApi from 'component/waterfall/baseMasonry'
import { request } from 'meinian-package/src/utils'
import Button from 'meinian-package/src/baseComponent/button'
import globalData from 'meinian-package/src/common/globalData'
import util from 'meinian-package/src/utils/util'
import Card from './card'
import styles from './index.module.less'

export default () => {
  const [visible, setVisible] = useState(0)

  useEffect(() => {
    globalData.get('mn-new-students', setVisible, 1)
  }, [])

  const _onClose = () => {
    globalData.set('mn-new-students', 0)
    setVisible(0)
  }

  return <span>
    {!!visible && <Content onClose={_onClose} />}
  </span>
}

const Content = ({ onClose }) => {
  const [data, setData] = useState([])
  const fetchData = async () => {
    const result = await request.post('/zhikuan/image-bus/inspiration/list-share-blog?start=0&pageSize=100', {
      qualityFlag: 0,
      duplicateFilter: 0,
      subscribeType: 0,
      rankStatus: 1,
      sortOrderStatus: 0,
      shareUrl: (process.env.NODE_ENV === 'development') ? 'eyJpbnNwaXJhdGlvbklkIjo0MDM3Nn0=' : 'eyJpbnNwaXJhdGlvbklkIjoxMTM0NzB9',
      childrenFlag: 0,
      start: 0,
      pageSize: 100
    })
    setData(result.resultList)
  }

  useEffect(() => {
    fetchData()
  }, [])

  return <div className={styles['new-students']}>
    <div className="new-students-header-bg" />
    <div className="new-students-header">
      <img className="new-students-header-logo" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/logo_text.png" />
      <Button type="primary" onClick={onClose}>跳过，直接进入美念</Button>
    </div>
    <div className="new-students-content">
      <div className="new-students-content-title">
        <div className="new-students-content-title-weight">通过采集添加图片到美念</div>
        <div className="new-students-content-title-info">点击任一图片左上角的「采集」按钮，添加图片到美念</div>
      </div>
      <div style={{ padding: '0 64px', marginTop: '48px' }}>
        <WaterfallApi
          data={data}
          renderItem={(item, width, index) => <Card
            {...item}
            key={index}
            index={index}
            columnWidth={width}
            itemData={item}
            onCollect={() => {
              globalData.set('mn-new-students', 0)
              util.track('mn_newuser_click', {
                module1: '首页迎新',
              })
            }}
          />}
          columnCount={4}
          gutter={20}
        />
      </div>
    </div>
  </div>
}
